import { render, staticRenderFns } from "./OlDragAndDropFileInput.vue?vue&type=template&id=526f1fc5&scoped=true&"
import script from "./OlDragAndDropFileInput.vue?vue&type=script&lang=js&"
export * from "./OlDragAndDropFileInput.vue?vue&type=script&lang=js&"
import style0 from "./OlDragAndDropFileInput.vue?vue&type=style&index=0&id=526f1fc5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526f1fc5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VFileInput,VIcon,VSheet})
